"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _reactDnd = require("react-dnd");

var _UIMoveableObject = _interopRequireDefault(require("UIComponents/draggable/UIMoveableObject"));

var _Small = _interopRequireDefault(require("UIComponents/elements/Small"));

var _StripHtmlFromString = require("FormsCommonUtils/StripHtmlFromString");

var isUnsupportedBrowser;

var CustomDragLayer =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(CustomDragLayer, _PureComponent);
  (0, _createClass2.default)(CustomDragLayer, null, [{
    key: "propTypes",
    get: function get() {
      return {
        clientOffset: _react.PropTypes.shape({
          x: _react.PropTypes.number.isRequired,
          y: _react.PropTypes.number.isRequired
        }),
        isDragging: _react.PropTypes.bool.isRequired,
        item: _react.PropTypes.shape({
          formFieldLabel: _react.PropTypes.string,
          propertyLabel: _react.PropTypes.string,
          label: _react.PropTypes.string,
          isCreateNewField: _react.PropTypes.bool,
          isFormLabelPropertyEnabled: _react.PropTypes.bool
        }),
        isFormLabelPropertyEnabled: _react.PropTypes.bool
      };
    }
  }]);

  function CustomDragLayer() {
    var _this;

    (0, _classCallCheck2.default)(this, CustomDragLayer);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(CustomDragLayer).call(this));
    isUnsupportedBrowser = _this.isUnsupportedBrowser();
    return _this;
  }

  (0, _createClass2.default)(CustomDragLayer, [{
    key: "isUnsupportedBrowser",
    value: function isUnsupportedBrowser() {
      var userAgent = window.navigator.userAgent;
      return userAgent.indexOf('Edge/') !== -1 || userAgent.indexOf('Trident/') !== -1 || userAgent.indexOf('MSIE ') !== -1;
    }
  }, {
    key: "getStyles",
    value: function getStyles() {
      var clientOffset = this.props.clientOffset;

      if (!clientOffset) {
        return {
          display: 'none'
        };
      }

      var x = clientOffset.x,
          y = clientOffset.y;
      var transform = "translate(" + x + "px, " + y + "px)";
      return {
        transform: transform
      };
    }
  }, {
    key: "renderLabel",
    value: function renderLabel() {
      var _this$props = this.props,
          item = _this$props.item,
          isFormLabelPropertyEnabled = _this$props.isFormLabelPropertyEnabled;
      var label = item.formFieldLabel || item.propertyLabel || item.label;
      var name = item.formFieldName || item.propertyName || item.name;
      var isEnabled = isFormLabelPropertyEnabled || item.isFormLabelPropertyEnabled;
      return _react.default.createElement("span", null, _react.default.createElement("span", null, (0, _StripHtmlFromString.stripHtmlFromString)(label)), isEnabled ? _react.default.createElement(_Small.default, {
        use: "help"
      }, " (", name, ")") : null);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          isDragging = _this$props2.isDragging,
          _this$props2$item = _this$props2.item,
          item = _this$props2$item === void 0 ? {} : _this$props2$item;

      if (!isDragging || isUnsupportedBrowser || item.isCreateNewField) {
        return null;
      }

      return _react.default.createElement("div", {
        className: "forms-panel-custom-drag-layer-container"
      }, _react.default.createElement(_UIMoveableObject.default, {
        closeable: false,
        draggable: true,
        style: this.getStyles(),
        className: "forms-panel-custom-drag-layer"
      }, this.renderLabel()));
    }
  }]);
  return CustomDragLayer;
}(_react.PureComponent);

var collect = function collect(monitor) {
  return {
    isDragging: monitor.isDragging(),
    clientOffset: monitor.getClientOffset(),
    item: monitor.getItem()
  };
};

var _default = (0, _reactDnd.DragLayer)(collect)(CustomDragLayer);

exports.default = _default;
module.exports = exports.default;